import { apiGet } from "../client";
import type {
  IExamAssignmentListParams,
  IExamAssignmentListResponse,
} from "./types";
import { useQuery } from "@tanstack/react-query";

export async function getExamAssignmentList(params: IExamAssignmentListParams) {
  const response = await apiGet<IExamAssignmentListResponse>(
    "/exam_assignments",
    params
  );
  return response.data;
}

export function useQueryGetExamAssignmentList(
  params: IExamAssignmentListParams
) {
  return useQuery({
    queryKey: ["examAssignments", params],
    queryFn: () => getExamAssignmentList(params),
  });
}
